import styled from "styled-components";

export const SportIcon = styled.img`
  height: 17px;
`